import CapturePage from '../../components/CapturePage';
import LayoutScreen from '../../components/layout';
import imgBanner from '../../assets/image/banner-1.png';
import imgBannerMobile from '../../assets/image/banner.png';
import imgProduk1 from '../../assets/image/img-produk-1.png';
import iconScan from '../../assets/icon/icon_scan.svg';
import iconArrowRight from '../../assets/icon/icon_arrow_right.svg';
import Button from '../../components/button';
import ButtonLarge from '../../components/buttonLarge';
import { useNavigate } from 'react-router-dom';
import { clearBiodata } from '../../utils/helper';
import axios from 'axios';
import CONFIG from '../../config/apiConfig';
import { useEffect, useState } from 'react';
import parse from 'html-react-parser';

const PageHome = (props) => {
  const navigate = useNavigate();
  const [dataHome, setDataHome] = useState(null);

  useEffect(() => {
    fetshDataHome();
  }, []);

  const handleMulaiPeriksa = () => {
    clearBiodata();
    navigate('/biodata'); // Programmatically navigate to /new-route
  };

  const fetshDataHome = async () => {
    try {
      const response = await axios.get(CONFIG.API_URL + '/homecontent/detail');
      setDataHome(response?.data?.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  return (
    <LayoutScreen background={dataHome?.background_image}>
      <div className=" relative flex flex-col flex-grow xl:justify-end items-start h-full px-5 pb-5 xl:p-10">
        <div className="xl:hidden w-full relative mb-4">
          <img
            src={dataHome?.background_image_mobile}
            className=" w-full object-cover object-right-bottom"
            alt=""
          />
          <div className="absolute z-10 bottom-0 h-10 w-full bg-gradient-to-b from-transparent to-white"></div>
        </div>

        <div className="bg-transparent w-full xl:w-full flex flex-col items-center xl:items-start">
          <h1 className="w-64 xl:w-96 uppercase text-red font-bold text-4xl xl:text-6xl text-center xl:text-left">
            {dataHome?.title}
          </h1>
          <div className="text-textGray my-6 xl:my-6 text-center xl:text-left text-lg xl:text-xl xl:max-w-md">
            {parse(dataHome?.description ?? '')}
          </div>

          <div className="hidden xl:block w-full xl:w-max px-10 xl:px-0">
            <Button
              label="Periksa Kulit Anda"
              icon={iconScan}
              onClick={() => handleMulaiPeriksa()}
            />
          </div>

          <div className="block xl:hidden  w-full px-4">
            <ButtonLarge
              label="Periksa Kulit Anda"
              icon={iconScan}
              onClick={() => handleMulaiPeriksa()}
            />
          </div>
        </div>
        <div className="bg-darkCream w-full xl:max-w-lg rounded-md xl:rounded-3xl p-3 xl:p-6 flex space-x-4 mt-10 xl:mt-10">
          {/* <div className="flex flex-none justify-center w-24 h-24 xl:w-48 xl:h-48 items-center bg-white p-2 xl:p-8 rounded-lg">
            <img
              src={dataHome?.image_path}
              alt=""
              className="w-full h-full object-contain"
            />
          </div> */}
          <div className='w-full'>
            <div
              onClick={() => navigate('/produk')}
              className="cursor-pointer flex justify-between items-center w-full">
              <h2 className="capitalize text-textBlack font-bold text-sm xl:text-2xl">
                {dataHome?.title_information}
              </h2>
              <img
                src={iconArrowRight}
                alt="icon arrow right"
                className="w-5 h-5 xl:w-8 xl:h-8 object-contain"
              />
            </div>
            <p className="text-textGray text-xs xl:text-base mt-1 xl:mt-2">
              {parse(dataHome?.description_information ?? '')}
            </p>
          </div>
        </div>
      </div>
    </LayoutScreen>
  );
};

export default PageHome;
